<template>
  <NuxtLayout>
    <slot />
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { isChinese } from '@/utils/area';
import { GENERIC_ACTION_KEYS } from '@rendora/common/entities/app_cfg';
import '@rendora/design/styles/atom.scss';
import '@rendora/design/styles/normalize.css';
import 'swiper/css';
import 'swiper/css/pagination';
import { BROADCAST_KEY } from '~/constants/config';
import { useFixedRightBottom } from './composables/fixedRightBottom';
import { showFeedback } from './hooks/useModal/modals/feedback';

import { usePayment } from '@rendora/common/features/payment/store';

const route = useRoute();

const { hasActionPermission } = usePageAndActionPermissionData();
const paymentStore = usePayment();

const option = useFixedRightBottom();
option.value.onlineService = isChinese() && hasActionPermission(GENERIC_ACTION_KEYS.FLOAT_COMPS);

onMounted(() => {
  // 初始化一下折扣信息
  paymentStore.fetchDiscount();

  // 显示反馈弹窗
  if (route.query.feedback) showFeedback();
  onBroadcast(BROADCAST_KEY.REFRESH, (data: any) => {
    const { tabId } = data;
    if (tabId !== TAB_ID) {
      location.reload();
    }
  });
});
</script>

<style lang="scss" scoped>
.main-wrapper {
  &::before {
    display: block;
    content: '';
    width: 100%;
    height: calc($top-height - 1px);
    z-index: 999;
  }
}
</style>
